<template>
  <NoItem v-if="noItem" />
  <template v-else>
    <v-layout
      v-if="login.profile.is_admin && profile && !home"
      row
      class="mb-4"
    >
      <v-spacer />
      <v-btn
        flat
        color="secondary"
        @click="openDeleteDialog()"
      >
        <v-icon class="mr-1">
          mdi-delete
        </v-icon>
        {{ $t('User.DeleteThisUser') }}
      </v-btn>
    </v-layout>
    <TwoColumnPageLayout>
      <!-- 左ペイン -->
      <template #first>
        <OutSideTitleCard :title="$t('User.Profile')">
          <ProfileContent
            :profile="profile"
            @reload="get()"
          />
        </OutSideTitleCard>
      </template>

      <!-- 右ペイン -->
      <template
        v-if="profile !== null"
        #second
      >
        <div class="mb-5">
          <OutSideTitleCard :title="$t('Service.Service')" no-padding>
            <UserAssignServicesContent :user-id="profile.id" read-only />
          </OutSideTitleCard>
        </div>
        <div>
          <OutSideTitleCard
            :title="$t('AuthDevice.AuthDevices')"
            no-padding
          >
            <UserAuthDevicesContent :user-id="profile.id" />
          </OutSideTitleCard>
        </div>
      </template>
    </TwoColumnPageLayout>

    <!-- 削除ダイアログ -->
    <DeleteDialog
      v-if="profile !== null"
      v-model="deleteDialog"
      :api-address="'users/' + profile.id + '/'"
      @reload="afterDelete()"
    >
      {{ $t('User.DeleteInfo') }}
      <v-alert
        v-if="isMyself"
        type="error"
        :value="true"
      >
        {{ $t('User.FormInfo.DeleteMyselfAccountAlert') }}
      </v-alert>
    </DeleteDialog>
  </template>
</template>

<script>
  import { mapGetters } from 'vuex'
  import TwoColumnPageLayout from '../pages/layouts/TwoColumnPageLayout'
  import OutSideTitleCard from '../parts/card/OutSideTitleCard'
  import ProfileContent from '../content/ProfileContent'
  import UserAssignServicesContent from '../content/UserAssignServicesContent'
  import UserAuthDevicesContent from '../content/UserAuthDevicesContent'
  import DeleteDialog from '../dialogs/DeleteDialog'
  import NoItem from '../content/NoItem'

  export default {
    components: {
      NoItem,
      DeleteDialog,
      UserAuthDevicesContent,
      UserAssignServicesContent,
      ProfileContent,
      OutSideTitleCard,
      TwoColumnPageLayout
    },
    props: {
      home: Boolean
    },
    data: () => ({
      profile: null,
      deleteDialog: false,
      noItem: false
    }),
    computed: {
      ...mapGetters(['login']),
      userId () {
        return this.$route.params.id ? this.$route.params.id : this.login.user_id
      },
      isMyself () {
        if (this.profile) {
          return this.profile.id === this.login.user_id
        } else {
          return false
        }
      }
    },
    watch: {
      '$route' (to, from) {
        this.profile = null
        this.get()
      },
      userId () {
        this.get()
      }
    },
    created () {
      this.get()
    },
    methods: {
      get () {
        if (!this.userId) return
        this.$http(`users/${this.userId}/`).then(
          (res) => {
            this.profile = res.data
            if (this.userId === this.login.profile.id) {
              res.data.is_admin = false
              res.data.roles.forEach((role) => {
                if (role === 'admin') {
                  res.data.is_admin = true
                }
              })
              this.$store.dispatch('login', { profile: res.data })
            }
          },
          (error) => {
            if (error.response.status === 404) {
              this.noItem = true
            }
          })
      },
      openDeleteDialog () {
        this.deleteDialog = true
      },
      afterDelete () {
        this.$router.push({ name: 'ManageAccounts' })
      }
    }
  }
</script>

<style scoped>

</style>
